// extracted by mini-css-extract-plugin
module.exports = {"gridMain":"CardList_gridMain__2y5E8"};